// import { VisionStudioTabs } from "../../components";

import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { useEffect } from "react";
import { fetchSubscriptionExpiry } from "../../store/slice/authSlice";
import updateBg from "../../assets/img/update-bg.png";
import { useNavigate } from "react-router-dom";

/**
 *
 * Componet to display Home page UI.
 *
 */
const Updates: React.FC = () => {
  const navigate = useNavigate();
  const handleRenew = () => {
    const plan = localStorage.getItem("plan");
    if (plan === "Institution") {
      navigate("/myplan");
    } else {
      const customerId = localStorage.getItem("customerId");
      window.open(
        `/upgrade/plan`,
        "_blank"
      );
    }
  };

  const dispatch: AppDispatch = useDispatch();

  const { subscriptionDays, subscriptionPlan } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    dispatch(fetchSubscriptionExpiry());
  }, []);

  const plan = localStorage.getItem("plan");

  return (
    <Box
      sx={{
        flexGrow: "1",
      }}
    >
      <Box sx={{ background: "white", borderRadius: "6px", padding: "10px" }}>
        {subscriptionDays !== null ? (
          <Typography sx={{ color: "#5B6871", lineHeight: "20px" }}>
            {subscriptionDays >= 0 ? (
              <>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "40px",
                    color: "black",
                  }}
                >
                  Current Plan:
                  <span style={{ color: "#4094F7" }}> {subscriptionPlan}</span>
                </Typography>
                plan expires {subscriptionDays == 0 ? "" : `in`}:{" "}
                <span style={{ color: "black" }}>
                  {subscriptionDays == 0 ? "Today" : `${subscriptionDays} days`}
                </span>
              </>
            ) : (
              "plan expired"
            )}
          </Typography>
        ) : (
          ""
        )}

        <Button
         // id="renewNow"
          variant="contained"
          sx={{ marginTop: "15px", background: "#FF1C379C" }}
          onClick={handleRenew}
        >
          {plan === "Institution" ? "My Plan" : "Renew Now"}
        </Button>
      </Box>
      <Box
        sx={{
          background: "white",
          borderRadius: "6px",
          padding: "10px 0 0 10px",
          marginTop: "10px",
        }}
      >
        <Typography
          variant="h3"
          sx={{ fontSize: "18px", fontWeight: "500", lineHeight: "30px" }}
        >
          Updates and announcements
        </Typography>
        {/* <List
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            overflow: "scroll",
            height: "calc(100vh - 480px)",
          }}
        >
          <ListItem sx={{ padding: "8px" }}>
            <ListItemAvatar>
              <Avatar alt="Person 3"></Avatar>
            </ListItemAvatar>
            <ListItemText
              sx={{ flex: "1 1 55%" }}
              primary="Photos"
              secondary={
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Dataset:
                    <span>234</span>
                    <span style={{ margin: "0 5px" }}>|</span>
                  </p>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Labels:
                    <span>234</span>
                  </p>
                </Box>
              }
            ></ListItemText>
            <ListItemText
              sx={{
                alignSelf: "self-start",
                textAlign: "end",
                fontSize: "12px",
              }}
            >
              <MoreVertIcon />{" "}
            </ListItemText>
          </ListItem>
          <ListItem sx={{ padding: "8px" }}>
            <ListItemAvatar>
              <Avatar alt="Person 3"></Avatar>
            </ListItemAvatar>
            <ListItemText
              sx={{ flex: "1 1 55%" }}
              primary="Photos"
              secondary={
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Dataset:
                    <span>234</span>
                    <span style={{ margin: "0 5px" }}>|</span>
                  </p>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Labels:
                    <span>234</span>
                  </p>
                </Box>
              }
            ></ListItemText>
            <ListItemText
              sx={{
                alignSelf: "self-start",
                textAlign: "end",
                fontSize: "12px",
              }}
            >
              <MoreVertIcon />{" "}
            </ListItemText>
          </ListItem>
          <ListItem sx={{ padding: "8px" }}>
            <ListItemAvatar>
              <Avatar alt="Person 3"></Avatar>
            </ListItemAvatar>
            <ListItemText
              sx={{ flex: "1 1 55%" }}
              primary="Photos"
              secondary={
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Dataset:
                    <span>234</span>
                    <span style={{ margin: "0 5px" }}>|</span>
                  </p>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Labels:
                    <span>234</span>
                  </p>
                </Box>
              }
            ></ListItemText>
            <ListItemText
              sx={{
                alignSelf: "self-start",
                textAlign: "end",
                fontSize: "12px",
              }}
            >
              <MoreVertIcon />
            </ListItemText>
          </ListItem>
          <ListItem sx={{ padding: "8px" }}>
            <ListItemAvatar>
              <Avatar alt="Person 3"></Avatar>
            </ListItemAvatar>
            <ListItemText
              sx={{ flex: "1 1 55%" }}
              primary="Photos"
              secondary={
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Dataset:
                    <span>234</span>
                    <span style={{ margin: "0 5px" }}>|</span>
                  </p>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Labels:
                    <span>234</span>
                  </p>
                </Box>
              }
            ></ListItemText>
            <ListItemText
              sx={{
                alignSelf: "self-start",
                textAlign: "end",
                fontSize: "12px",
              }}
            >
              <MoreVertIcon />
            </ListItemText>
          </ListItem>
          <ListItem sx={{ padding: "8px" }}>
            <ListItemAvatar>
              <Avatar alt="Person 3"></Avatar>
            </ListItemAvatar>
            <ListItemText
              sx={{ flex: "1 1 55%" }}
              primary="Photos"
              secondary={
                <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Dataset:
                    <span>234</span>
                    <span style={{ margin: "0 5px" }}>|</span>
                  </p>
                  <p style={{ fontSize: "12px", margin: "0" }}>
                    Labels:
                    <span>234</span>
                  </p>
                </Box>
              }
            ></ListItemText>
            <ListItemText
              sx={{
                alignSelf: "self-start",
                textAlign: "end",
                fontSize: "12px",
              }}
            >
              <MoreVertIcon />
            </ListItemText>
          </ListItem>
        </List> */}
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            overflow: "scroll",
            height: "calc(100vh - 440px)",
            alignContent: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              boxShadow: "0px 0px 8px  #0000003D",
              borderRadius: "6px",
              width: "85%",
              margin: "10px auto",
            }}
          >
            <Box>
              <img
                src={updateBg}
                alt="updateBg"
                style={{
                  maxHeight: "190px",
                  width: "100%",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                }}
              />
            </Box>
            <Box
              sx={{
                background: "#161616CC",
                position: "absolute",
                top: "40%",
                width: "52%",
                color: "white",
                padding: "10px",
              }}
            >
              <Typography sx={{ fontSize: "12px" }}>
                Launch Update: More Features, Less Hassle
              </Typography>
            </Box>
            <Box sx={{ padding: "10px" }}>
              <Typography>New Year, New Possibilities 🎉</Typography>
              <span style={{ fontSize: "9px", color: "#666666" }}>
                Exciting News: The Launch Is Here with More Features!
              </span>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Updates;
